import style from "./ControlPanel.module.scss";
import { Buttons, OtherActions } from "./components";

export function ControlPanel() {
    return (
        <div className={style.container}>
            <OtherActions />
            <Buttons />
        </div>
    )
}

